import React, { useId } from 'react';
interface SelectOption {
  value: string;
  label: string;
}
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: SelectOption[];
  error?: string;
}
export function Select({
  label,
  options,
  error,
  className = '',
  id,
  ...props
}: SelectProps) {
  const selectId = id || useId();
  return <div className="w-full space-y-2" data-id="element-120">
      {label && <label htmlFor={selectId} className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70" data-id="element-121">
          {label}
        </label>}
      <select id={selectId} className={`flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${error ? 'border-destructive focus-visible:ring-destructive' : ''} ${className}`} {...props} data-id="element-122">
        <option value="" disabled selected data-id="element-123">
          انتخاب کنید...
        </option>
        {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-124">
            {opt.label}
          </option>)}
      </select>
      {error && <p className="text-sm font-medium text-destructive" data-id="element-125">{error}</p>}
    </div>;
}